export default class ReportFields {
  constructor() {
    this.item_inspecao = [
      { key: "quantidade", label: "Quantidade", sortable: false },
      { key: "descricao", label: "Descrição", sortable: false },
      { key: "local", label: "Local", sortable: false },
      { key: "tipo", label: "Tipo", sortable: false },
      { key: "dimensao", label: "Dimensão", sortable: false },
      { key: "laudo", label: "Laudo", sortable: false },
    ];

    this.item_checklist = [
      { key: "item", label: "Item", sortable: true, thStyle: { width: "6%" } },
      { key: "conjunto", label: "Subconjunto", sortable: false, thStyle: { width: "25%" } },
      { key: "descricao", label: "Descrição", sortable: false, thStyle: { width: "59%" } },
      { key: "laudo", label: "Laudo", sortable: false, thStyle: { width: "10%" } },
    ];

    this.item_manutencao = [
      { key: "item", label: "Item", sortable: false, thStyle: { width: "60%" } },
      { key: "intervalo", label: "Intervalo", sortable: false, thStyle: { width: "20%" } },
      { key: "historico", label: "Histórico", sortable: false, thStyle: { width: "20%" } },
    ];

    this.item_componente = [
      { key: "item", label: "Item", sortable: false, thStyle: { width: "10%" } },
      { key: "descricao", label: "Descrição", sortable: false, thStyle: { width: "90%" } },
    ];

    this.item_norma = [
      { key: "item", label: "Item", sortable: false, thStyle: { width: "30%" } },
      { key: "descricao", label: "Descrição", sortable: false, thStyle: { width: "70%" } },
    ];

    this.item_operacional = [
      { key: "item", label: "Item", sortable: false, thStyle: { width: "10%" } },
      { key: "descricao", label: "Descrição", sortable: false, thStyle: { width: "50%" } },
      { key: "condicao", label: "Condição", sortable: false, thStyle: { width: "40%" } },
    ];

    this.item_risco = [
      { key: "item", label: "Item", sortable: false, thStyle: { width: "10%" } },
      { key: "descricao", label: "Descrição", sortable: false, thStyle: { width: "90%" } },
    ];

    this.item_mecanico = [
      { key: "item", label: "Item", sortable: false, thStyle: { width: "10%" } },
      { key: "descricao", label: "Descrição", sortable: false, thStyle: { width: "20%" } },
      { key: "avaliacao", label: "Avaliação", sortable: false, thStyle: { width: "70%" } },
    ];

    this.item_eletrico = [
      { key: "item", label: "Item", sortable: false, thStyle: { width: "10%" } },
      { key: "descricao", label: "Descrição", sortable: false, thStyle: { width: "20%" } },
      { key: "avaliacao", label: "Avaliação", sortable: false, thStyle: { width: "70%" } },
    ];

    this.item_motores = [
      { key: "item", label: "Item", sortable: false, thStyle: { width: "10%" } },
      { key: "descricao", label: "Descrição", sortable: false, thStyle: { width: "30%" } },
      { key: "avaliacao", label: "Avaliação", sortable: false, thStyle: { width: "60%" } },
    ];

    this.item_recomendacoes = [
      { key: "item", label: "Item", sortable: false, thStyle: { width: "10%" } },
      { key: "recomendacao", label: "Recomendação", sortable: false, thStyle: { width: "90%" } },
    ];
  }
}
